export default __webpack_public_path__ + "static/slider-1-d1a8f21b27866b4c9626409ca46045df.jpg";